"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentHubBridgeStates = exports.P2PPaymentDepositExitStates = exports.P2PPaymentDepositWithdrawalStates = exports.P2PPaymentChannelPaymentStates = exports.P2PPaymentChannelStates = exports.DEFAULT_PAYMENT_CHANNEL_UID_SALT = exports.PAYMENT_HUB_P2P_CHANNEL_UID = void 0;
const ethers_1 = require("ethers");
exports.PAYMENT_HUB_P2P_CHANNEL_UID = ethers_1.utils.id('PAYMENT_HUB_P2P_CHANNEL_ID');
exports.DEFAULT_PAYMENT_CHANNEL_UID_SALT = 'default';
var P2PPaymentChannelStates;
(function (P2PPaymentChannelStates) {
    P2PPaymentChannelStates["Opened"] = "Opened";
    P2PPaymentChannelStates["Signed"] = "Signed";
})(P2PPaymentChannelStates = exports.P2PPaymentChannelStates || (exports.P2PPaymentChannelStates = {}));
var P2PPaymentChannelPaymentStates;
(function (P2PPaymentChannelPaymentStates) {
    P2PPaymentChannelPaymentStates["Reserved"] = "Reserved";
    P2PPaymentChannelPaymentStates["Signed"] = "Signed";
    P2PPaymentChannelPaymentStates["Expired"] = "Expired";
    P2PPaymentChannelPaymentStates["Committed"] = "Committed";
})(P2PPaymentChannelPaymentStates = exports.P2PPaymentChannelPaymentStates || (exports.P2PPaymentChannelPaymentStates = {}));
var P2PPaymentDepositWithdrawalStates;
(function (P2PPaymentDepositWithdrawalStates) {
    P2PPaymentDepositWithdrawalStates["Signed"] = "Signed";
    P2PPaymentDepositWithdrawalStates["Withdrawn"] = "Withdrawn";
})(P2PPaymentDepositWithdrawalStates = exports.P2PPaymentDepositWithdrawalStates || (exports.P2PPaymentDepositWithdrawalStates = {}));
var P2PPaymentDepositExitStates;
(function (P2PPaymentDepositExitStates) {
    P2PPaymentDepositExitStates["Requested"] = "Requested";
    P2PPaymentDepositExitStates["Rejected"] = "Rejected";
    P2PPaymentDepositExitStates["Completed"] = "Completed";
})(P2PPaymentDepositExitStates = exports.P2PPaymentDepositExitStates || (exports.P2PPaymentDepositExitStates = {}));
var PaymentHubBridgeStates;
(function (PaymentHubBridgeStates) {
    PaymentHubBridgeStates["Active"] = "Active";
    PaymentHubBridgeStates["Inactive"] = "Inactive";
})(PaymentHubBridgeStates = exports.PaymentHubBridgeStates || (exports.PaymentHubBridgeStates = {}));
